import { secretStorage } from "config"
import { useCallback } from "react"


const useGetBlurredAssesment = () => {

    return useCallback((ass) => {
        const user = secretStorage.getItem("user")
        const { is_superuser } = user || {}

        if (!is_superuser && ass.assessment_hidden)
            return true
        return false
    }, [])

}

export default useGetBlurredAssesment